export enum AlertRuleName {
  SHORT_CIRCUIT = 'ShortCircuit',
  OVERLOADED_CURRENT = 'OverloadedCurrent',
  HIGH_CURRENT = 'HighCurrent',
  LOW_CURRENT = 'LowCurrent',
  HIGH_VOLTAGE = 'HighVoltage',
  LOW_VOLTAGE = 'LowVoltage',
  NO_VOLTAGE = 'NoVoltage',
  DEVICE_OFFLINE = 'DeviceOffline',
  HIGH_TEMPERATURE = 'HighTemperature',
  LOW_TEMPERATURE = 'LowTemperature',
  HIGH_HUMIDITY = 'HighHumidity',
  LOW_HUMIDITY = 'LowHumidity',
  HIGH_PRESSURE = 'HighPressure',
  LOW_PRESSURE = 'LowPressure',
  DEW_POINT = 'DewPoint',
  LOW_BATTERY = 'LowBattery',
  LOW_SIGNAL = 'LowSignal',
  CONDENSATION_RISK_INTAKE = 'CondensationRiskIntake',
  CONDENSATION_RISK_EXHAUST = 'CondensationRiskExhaust',
  EXHAUST_AIR_TOO_COLD = 'ExhaustAirTooCold',
  EXHAUST_AIR_TOO_HOT = 'ExhaustAirTooHot',
  HEATING_WHILE_VALVE_CLOSED = 'HeatingWhileValveClosed',
  NO_HEATING = 'NoHeating',
  TARGET_TEMPERATURE_NOT_REACHED = 'TargetTemperatureNotReached',
  RAPID_TEMPERATURE_DROP = 'RapidTemperatureDrop',
  RAPID_TEMPERATURE_RISE = 'RapidTemperatureRise',
  WEAK_SIGNAL = 'WeakSignal',
  UNKNOWN = 'Unknown'
}
